import CaptionExpand from "@/pages/Posts/PostEditor/PostEditor/components/PostPreview/components/CaptionExpand";
import classNames from "classnames";
import { Post } from "store/posts/postConstants";
import PostMediaRenderer from "../components/PostMediaRenderer";

interface PostCardFrontProps {
  post: Post;
  isRTL: boolean;
  onClick?: () => void;
}

const PostCardFront = ({ post, isRTL, onClick }: PostCardFrontProps) => {
  return (
    <div
      className={classNames("w-full h-full flex flex-col", {
        "cursor-pointer": !!onClick,
      })}
      onClick={onClick}
    >
      {/* Caption Section */}
      <div className="text-xs px-4 py-2">
        <CaptionExpand
          text={post.caption ?? ""}
          initialLines={4}
          showMoreText="Show more"
          showLessText="Show less"
          linkColor="gray"
          isRTL={isRTL}
        />
      </div>

      {/* Media Section */}
      <div className="relative flex-grow border-t border-antd-colorBorderSecondary">
        <PostMediaRenderer post={post} />
      </div>
    </div>
  );
};

export default PostCardFront;
